import { ImportManagerContent } from './ImportManagerContent';
import { ImportManagerProvider } from './ImportManagerContext';

type ImportManagerProps = {
  workspaceId: string;
  organizationId: string;
  draftId: string;
  currentDemoId: string;
  onLearnMore?: () => void;
  // these are passed down from EditorSDK
  onClose?: () => void;
  onImportEditsSuccess?: () => void;
  onImportEditsError?: () => void;
};

export const ImportManager = ({
  workspaceId,
  organizationId,
  draftId,
  currentDemoId,
  onClose,
  onImportEditsSuccess,
  onImportEditsError,
  onLearnMore,
}: ImportManagerProps) => (
  <ImportManagerProvider
    workspaceId={workspaceId}
    organizationId={organizationId}
    draftId={draftId}
    currentDemoId={currentDemoId}
  >
    <ImportManagerContent
      onClose={onClose}
      onImportEditsSuccess={onImportEditsSuccess}
      onImportEditsError={onImportEditsError}
      onLearnMore={onLearnMore}
    />
  </ImportManagerProvider>
);
